import React, { useEffect} from "react";
import { useNavigate } from "react-router";
import "./StaticPage.css";

const TermsPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="static-page">
            <div className="static-page-inner">

                <button
                    className="back-link"
                    onClick={() =>
                        window.history.length > 1 ? navigate(-1) : navigate("/")
                    }
                >
                    ← Back
                </button>
                <h1>Terms of Use</h1>
                <p className="static-page-meta">
                    Last updated: 1 December 2025
                </p>

                <p>
                    These Terms of Use ("Terms") govern your access to and use of
                    the art and collection management platform provided by
                    <strong> Art Management Hub</strong> (the "Service"). By
                    accessing or using the Service, you agree to be bound by these Terms.
                </p>

                <h2>1. Access to the Service</h2>
                <p>
                    The Service is licensed to authorised users on a non-exclusive, non-transferable basis, for the duration of their permitted access.
                </p>
                <p>
                    Access to the Service is provided on a restricted basis to invited or
                    approved users only. You must keep your login credentials confidential and
                    must not share them with any other person. You are responsible for all
                    activity that occurs under your account.
                </p>

                <h2>2. Use of the Service</h2>
                <p>You agree that you will:</p>
                <ul>
                    <li>Use the Service only for lawful purposes and in accordance with these Terms.</li>
                    <li>
                        Not attempt to gain unauthorised access to any part of the Service, or
                        to other users' data.
                    </li>
                    <li>
                        Not introduce malicious code, or interfere with the proper operation of the Service.
                    </li>
                    <li>
                        Respect any confidentiality obligations that apply to information you
                        access through the Service.
                    </li>
                </ul>

                <h2>3. Client data and content</h2>
                <p>
                    Our clients (such as family offices or related entities) remain responsible
                    for all data and content submitted to the Service, including any personal data,
                    images, documents, or valuation information relating to collections.
                </p>
                <p>
                    You confirm that you have the necessary rights and permissions to upload and
                    manage any content you submit and that such content does not infringe the rights
                    of any third party.
                </p>

                <h2>4. Intellectual property</h2>
                <p>
                    We (or our licensors) retain all rights, title, and interest in and to the Service,
                    including all software, documentation, user interfaces, and underlying technology.
                    These Terms do not grant you any ownership rights in the Service.
                </p>
                <p>
                    You may not copy, modify, reverse engineer, or create derivative works from any
                    part of the Service, except to the extent permitted by applicable law.
                </p>

                <h2>5. Confidentiality</h2>
                <p>
                    The Service is designed to support the management of sensitive and confidential
                    information relating to private collections. You agree to treat any information
                    accessed through the Service as confidential and to use it only for legitimate
                    purposes connected with your role.
                </p>

                <h2>6. Availability and changes</h2>
                <p>
                    We aim to provide a secure and reliable Service, but we do not guarantee that the
                    Service will be uninterrupted or error-free. We may modify, suspend, or discontinue
                    all or part of the Service from time to time, for example to apply updates,
                    implement improvements, or address security or compliance requirements.
                </p>

                <h2>7. Disclaimers</h2>
                <p>
                    The Service is provided on an "as is" and "as available" basis.
                    To the fullest extent permitted by law, we disclaim all warranties, whether express
                    or implied, including any warranties of fitness for a particular purpose, merchantability,
                    or non-infringement.
                </p>
                <p>
                    The Service is a tool to help structure and manage collection-related information.
                    It does not constitute legal, tax, valuation, or investment advice.
                </p>

                <h2>8. Limitation of liability</h2>
                <p>
                    To the fullest extent permitted by law, we shall not be liable for any indirect,
                    incidental, special, consequential, or punitive damages, or for any loss of profits
                    or data, arising out of or in connection with your use of the Service.
                </p>
                <p>
                    Our aggregate liability arising out of or in connection with the Service shall,
                    to the extent permitted by law, be limited to the amount paid to us for your use
                    of the Service during the twelve (12) months preceding the event giving rise to
                    the claim (if applicable).
                </p>

                <h2>9. Termination</h2>
                <p>
                    We may suspend or terminate your access to the Service if we reasonably believe
                    that you have breached these Terms, or where required to do so by law, regulation,
                    or at the request of the client that sponsors your access.
                </p>
                <p>
                    Upon termination, your right to access the Service will cease. Termination will not
                    affect any rights or obligations that have accrued up to that point.
                </p>

                <h2>10. Governing law</h2>
                <p>
                    These Terms, and any dispute arising out of or in connection with them, shall be
                    governed by and construed in accordance with the laws of the jurisdiction specified
                    in our client agreement or engagement documentation, without regard to conflict of
                    law principles.
                </p>

                <h2>11. Changes to these Terms</h2>
                <p>
                    We may update these Terms from time to time. If we make material changes, we will
                    provide notice through the Service or by other appropriate means. Your continued
                    use of the Service after any changes have taken effect constitutes your acceptance
                    of the updated Terms.
                </p>

                <h2>12. Contact</h2>
                <p>
                    If you have any questions about these Terms, please contact:
                </p>
                <p className="static-page-highlight">
                    Email: <a href="mailto:legal@artmanagementhub.com">legal@artmanagementhub.com</a>
                </p>
            </div>
        </div>
    );
};

export default TermsPage;
